/* eslint-disable max-classes-per-file */

class Lock {
  constructor(public name: string) {}
}

type LockTuple<T = any> = [
  (lock: Lock | null) => Promise<T> | T,
  (res: T) => void,
  (rej: Error) => void,
];
export type SimpleLockOptions = { ifAvailable?: boolean };

export class SimpleLockManager {
  locksHeld: Record<string, LockTuple[]> = {};

  _release(name: string) {
    if (this.locksHeld[name]) {
      this.locksHeld[name] = this.locksHeld[name].slice(1);
      if (this.locksHeld[name].length > 0) {
        const [cb, resolve, reject] = this.locksHeld[name][0];
        Promise.resolve(cb(new Lock(name)))
          .then(resolve, reject)
          .finally(() => this._release(name));
      } else {
        delete this.locksHeld[name];
      }
    }
  }

  request<T>(name: string, options: SimpleLockOptions, cb: ((lock: Lock) => Promise<T>)): Promise<T>;
  // eslint-disable-next-line
  request<T>(name: string, cb: ((lock: Lock) => Promise<T>)): Promise<T>;
  // eslint-disable-next-line
  async request<T>(name: string, options: any, cb?: any): Promise<T> {
    if (cb === undefined) {
      // eslint-disable-next-line no-param-reassign
      cb = options;
      // eslint-disable-next-line no-param-reassign
      options = {};
    }

    return new Promise((resolve, reject) => {
      const held = this.locksHeld[name];
      if (!held) {
        this.locksHeld[name] = [[cb, resolve, reject]];
        Promise.resolve(cb(new Lock(name)))
          .then(resolve, reject)
          .finally(() => this._release(name));
      } else if (options?.ifAvailable === true) {
        Promise.resolve(cb(null)).then(resolve, reject);
      } else {
        this.locksHeld[name].push([cb, resolve, reject]);
      }
    });
  }
}